import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { editForm, confirmForm, INSURED_FORM } from '../Actions/actions';
import { formName } from '../Constants/constants';
import Insured from '../Components/Insured/Insured';

const formValues = formValueSelector(formName);

const mapStateToProps = (state) => ({
  enabled: state.formPage.insured.enabled,
  confirmed: state.formPage.insured.confirmed,
  valid: state.formPage.insured.valid,
  insuredRenter: state.formPage.insured.insuredRenter,
  insuredFirstName: formValues(state, 'insuredFirstName'),
  insuredLastName: formValues(state, 'insuredLastName'),
  insuredCompany: formValues(state, 'insuredCompany'),
  insuredCompanyType: formValues(state, 'insuredCompanyType'),
  jointVentureType: formValues(state, 'jointVentureType'),
  insuredAddress: formValues(state, 'insuredAddress'),
  insuredCity: formValues(state, 'insuredCity'),
  insuredState: formValues(state, 'insuredState'),
  insuredZip: formValues(state, 'insuredZip'),
  insuredCountry: formValues(state, 'insuredCountry'),
  usStates: state.formPage.usStates,
});

const mapDispatchToProps = (dispatch) => ({
  edit: () => dispatch(editForm(INSURED_FORM)),
  confirm: () => dispatch(confirmForm(INSURED_FORM)),
});

const InsuredContainer = connect(mapStateToProps, mapDispatchToProps)(Insured);

export default InsuredContainer;
